import AuthService from "../login/auth.service";
import { comprobantes, transferencias } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ReimpresionCuentaTerceroService {
  async reimprimirLista(nroSocio, mes) {
    var data = JSON.stringify({ socioOrigen: nroSocio, mesAnho: mes });
    var config = {    
      method: "post",
      url: transferencias + "transferencia/tercero/reimprimir",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descargarComprobante(data){

    var _url = comprobantes + "comprobantes/v2/reimpresion/transferencias-cuenta-tercero"; 
    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }


}
export default new ReimpresionCuentaTerceroService();
